<template>
  <div>
    <el-form :inline="true" style="margin-bottom: 20px;">
      <el-form-item>
        <el-input
          v-model="searchForm.name"
          placeholder="问卷名称"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.questesTypeCode"
          placeholder="调查类型"
          clearable
          style="width: 150px">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in questesTypeOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.platformTypeCode"
          placeholder="投放渠道"
          clearable
          style="width: 150px">
          <el-option label="全部" value=""></el-option>
          <el-option label="网页/H5" value="WEB/H5"></el-option>
          <el-option label="链接" value="LINK"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.projectName"
          placeholder="问卷所属项目"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.createBy"
          placeholder="创建人"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="createTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="创建时间开始"
          end-placeholder="创建时间结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="updateTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="最后修改时间开始"
          end-placeholder="最后修改时间结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getSurveyList">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe>
      <el-table-column
        prop="name"
        label="问卷名称"
        width="200">
      </el-table-column>
      <el-table-column
        prop="questesTypeName"
        label="调查类型"
        width="150">
        <template slot-scope="scope">
          {{ scope.row.questesTypeName || scope.row.questesTypeCode || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="platformTypeName"
        label="投放渠道"
        width="150">
        <template slot-scope="scope">
          {{ scope.row.platformTypeName || scope.row.platformTypeCode || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="projectName"
        label="问卷所属项目"
        width="200">
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="创建人"
        width="150">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="180"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="180"
        label="最后修改时间">
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.current"
      :page-size="page.size"
      :total="page.total"
      style="margin-top: 20px; float: right;">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "ContentSurvey",
  data() {
    return {
      searchForm: {},
      createTimeRange: [],
      updateTimeRange: [],
      tableData: [],
      questesTypeOptions: [],
      page: {
        total: 0,
        size: 10,
        current: 1,
      }
    }
  },
  created() {
    this.getQuestesTypeList()
    this.getSurveyList()
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val
      this.getSurveyList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getSurveyList()
    },
    resetSearch() {
      this.searchForm = {}
      this.createTimeRange = []
      this.updateTimeRange = []
      this.page.current = 1
      this.getSurveyList()
    },
    getQuestesTypeList() {
      this.$axios.get("/uxm/questes-type/list").then(res => {
        if (res && res.data && res.data.data) {
          // 只获取启用状态的问卷类型（delFlag=0）
          this.questesTypeOptions = (res.data.data || []).filter(item => item.delFlag === 0)
        } else {
          this.questesTypeOptions = []
        }
      }).catch(error => {
        console.error('获取问卷类型列表失败:', error)
        this.questesTypeOptions = []
      })
    },
    getSurveyList() {
      const params = {
        name: this.searchForm.name || null,
        questesTypeCode: (this.searchForm.questesTypeCode === '' || this.searchForm.questesTypeCode == null) ? null : this.searchForm.questesTypeCode,
        platformTypeCode: (this.searchForm.platformTypeCode === '' || this.searchForm.platformTypeCode == null) ? null : this.searchForm.platformTypeCode,
        projectName: this.searchForm.projectName || null,
        createBy: this.searchForm.createBy || null,
        startCreateTime: this.createTimeRange && this.createTimeRange.length > 0 ? this.createTimeRange[0].split(' ')[0] : null,
        endCreateTime: this.createTimeRange && this.createTimeRange.length > 0 ? this.createTimeRange[1].split(' ')[0] : null,
        startUpdateTime: this.updateTimeRange && this.updateTimeRange.length > 0 ? this.updateTimeRange[0].split(' ')[0] : null,
        endUpdateTime: this.updateTimeRange && this.updateTimeRange.length > 0 ? this.updateTimeRange[1].split(' ')[0] : null,
        current: this.page.current,
        size: this.page.size,
      }
      this.$axios.post("/uxm/content/survey/page", params).then(res => {
        if (res && res.data && res.data.data) {
          this.tableData = res.data.data.records || []
          this.page.size = res.data.data.size || 10
          this.page.current = res.data.data.current || 1
          this.page.total = res.data.data.total || 0
        } else {
          this.tableData = []
          this.page.total = 0
        }
      }).catch(error => {
        console.error('获取问卷列表失败:', error)
        this.tableData = []
        this.page.total = 0
      })
    }
  }
}
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>

